import { BaseButton } from '../BaseButton';
import { withFocusable } from 'helpers';

export const SoundButton = withFocusable(BaseButton);
